<div class="full-popup-head">
  <div class="full-popup-title flex">
    <em *ngIf="!isShowNewWorkflow" class="modal-title-icon icon-stock-count"></em
    >{{
      isShowNewWorkflow
        ? 'View Approval Workflow'
        : canApproveReject
          ? 'Approve Store Available Adjustment Request'
          : data.title
    }}
  </div>

  <button
    *ngIf="!isShowNewWorkflow"
    type="button"
    class="btn btn-header-button d-none d-md-block"
    id="historyBtn"
    data-id="historyBtn"
    (click)="onShowHistory()"
  >
    <em class="icon-history"></em>History
  </button>

  <div class="full-popup-close">
    <a
      aria-label="Close"
      id="closeBtn"
      data-id="closeBtn"
      class="close"
      (click)="isShowNewWorkflow ? onBack() : onClose()"
    >
      <em class="icon-close"></em>
    </a>
  </div>
  <div class="clearfix"></div>
</div>
<ng-container *ngIf="storeAvailableAdjustmentView">
  @if (!isShowNewWorkflow) {
    <div class="admin-form">
      <div class="info-header-container border-bottom-0">
        <div class="info-header-item">
          <div class="info-header-label">
            <span>Request No.:</span>
          </div>
          <div class="info-header-value">
            <span id="requestNo" data-id="requestNo">{{ storeAvailableAdjustmentView.docNo }}</span>
          </div>
        </div>
        <div class="info-header-item">
          <div class="info-header-label">
            <span>Reference No.:</span>
          </div>
          <div class="info-header-value">{{ storeAvailableAdjustmentView.refDoc }}</div>
        </div>

        <div class="info-header-item">
          <div class="info-header-label">
            <span>Status:</span>
          </div>
          <div class="info-header-value">
            <span
              id="status"
              data-id="status"
              class="store-available-adjustment-status"
              [ngClass]="getColorStatus | pureFn: storeAvailableAdjustmentView?.status"
              >{{
                'STORE_AVAILABLE_ADJUSTMENT_REQUEST.STATUS.' + storeAvailableAdjustmentView?.status | translate
              }}</span
            >
          </div>
        </div>
      </div>

      <div class="information-container mb-3">
        <div class="container-fluid px-0">
          <div class="row">
            <div class="col-lg col-md-3 flex-column">
              <div class="info-header-label">
                <span> Store </span>
              </div>
              <div class="info-header-value text-break">
                <span id="storeCodeName" data-id="storeCodeName">{{
                  storeAvailableAdjustmentView.storeCodeName
                }}</span>
              </div>
            </div>

            <div class="col-lg col-md-3 flex-column">
              <div class="info-header-label">
                <span>No. of item</span>
              </div>
              <div id="noOfItems" class="info-header-value">
                {{ storeAvailableAdjustmentView.noOfItems | numberFormatDisplay: 0 : 0 }}
              </div>
            </div>
            <div class="col-lg col-md-3 flex-column">
              <div class="info-header-label">
                <span>No. of Cancelled item</span>
              </div>
              <div id="noOfCancelledItems" class="info-header-value">
                {{ storeAvailableAdjustmentView.noOfCancelledItems | numberFormatDisplay: 0 : 0 }}
              </div>
            </div>
            <div class="col-lg col-md-3 flex-column">
              <div class="info-header-label">
                <span>Requested By</span>
              </div>
              <div class="info-header-value" id="requestedBy">{{ storeAvailableAdjustmentView.requestedBy }}</div>
            </div>
            <div class="col-lg col-md-3 flex-column">
              <div class="info-header-label">
                <span>Requested Date</span>
              </div>
              <div class="info-header-value" id="requestedDate">
                {{ storeAvailableAdjustmentView.requestedDate | amFromUtc | amLocal | dateDisplay: dateTimeDisplay }}
              </div>
            </div>
            <div class="col-lg-3">
              @if (showTotalAmount) {
                <div class="total-amount">
                  <div class="text-right">
                    <span class="info-total" id="info-total">
                      {{
                        storeAvailableAdjustmentView.totalStoreAvailableAdjustmentAmount?.priceIncVat?.amount
                          | number: '1.2-2'
                      }}
                    </span>
                    <span class="info-total-currency" id="info-total-currency"> THB </span>
                  </div>
                  <div class="info-total-detail">
                    <span id="info-total-detail">
                      (Total Amount before VAT:
                      <span id="info-total-exc-vat">
                        {{ totalAmountExcVat | number: '1.2-2' }}
                      </span>
                      |
                    </span>
                    VAT:
                    <span id="info-total-vat">
                      {{
                        storeAvailableAdjustmentView.totalStoreAvailableAdjustmentAmount?.vat?.amount
                          | number: '1.2-2'
                      }})</span
                    >
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!isShowWorkflow; else workflow">
      @if (!storeAvailableAdjustmentView.byPassWorkFlow) {
        <div class="text-end d-flex justify-content-end py-2">
          <button type="button" class="btn btn-standard" (click)="onViewApprovalWorkflow()">
            <em class="icon-approval-workflow"></em>View Approval Workflow
          </button>
        </div>
      }
      <div class="row section-header justify-content-between">
        <span>Item List</span>
        <ng-container *ngIf="!isViewCancelled; else viewAllItem">
          <span class="view-item mr-3" (click)="onViewCancelledItems()"
            >View Cancelled Items ({{
              storeAvailableAdjustmentView.noOfCancelledItems | numberFormatDisplay: 0 : 0
            }})</span
          >
        </ng-container>
        <ng-template #viewAllItem>
          <span class="view-item mr-3" (click)="onViewCancelledItems()">View All Items</span>
        </ng-template>
      </div>
      <ng-container *ngIf="adjustItems.length > 0">
        <div class="table-responsive">
          <table id="data-table" class="table table-striped table-bordered w-100" aria-label="data-table">
            <thead>
              <tr>
                <th class="text-center w-5" scope="col">No.</th>
                <th class="text-center w-20" scope="col">Product Name</th>
                <th class="text-center w-10" scope="col">Counting Result</th>
                <th class="text-center w-10" scope="col">
                  Store Available Adjustment <br />
                  <span class="base-unit">(UOM: Base Unit)</span>
                </th>
                <th class="text-center w-10" scope="col">Amount (THB)</th>
                <th class="text-center w-20" scope="col">Remark</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of paging.currentPageData; index as i">
                <td class="text-center">{{ paging.pageSize * (paging.currentPage - 1) + (i + 1) }}</td>
                <td>
                  <div>
                    {{ item.productName }}
                  </div>
                  <div>
                    {{ item.articleNo }}
                  </div>
                </td>
                <td class="text-center">{{ item.adjustAvailableStock > 0 ? 'Positive' : 'Negative' }}</td>
                <td class="text-center">
                  {{ item.adjustAvailableStock > 0 ? '+' : ''
                  }}{{ item.adjustAvailableStock | numberFormatDisplay: 0 : 0 }}
                </td>
                <td class="text-right">{{ item.price?.priceIncVat?.amount | number: '1.2-2' }}</td>
                <td>{{ getRemarkMessage | pureFn: item }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <ng-container *ngIf="adjustItems.length === 0">
        <div class="no-result-container text-center">
          <div class="d-flex justify-content-center">
            <img alt="Data not found" [src]="env.assetPath + '/no-data.svg'" />
          </div>
        </div>
      </ng-container>
      <div class="white-space-nowrap">
        <app-ui-pagination
          #paging
          [(currentPage)]="currentPage"
          [(pageSize)]="pageSize"
          [items]="adjustItems"
          [pageSizeList]="pageSizeList"
          [valueChangeDetector]="adjustItems"
        >
        </app-ui-pagination>
      </div>
    </ng-container>
    <ng-template #workflow>
      <div class="actions-container">
        <perfect-scrollbar>
          <app-generate-approval-workflow [approvalSteps]="approvalWorkflow.steps"></app-generate-approval-workflow>
        </perfect-scrollbar>
      </div>
    </ng-template>

    <div class="fixed-row-bottom form-row" *ngIf="isShowWorkflow || canApproveReject">
      <div *ngIf="isShowWorkflow" class="float-left">
        <button (click)="onBack()" type="button" data-id="backBtn" id="backBtn" class="btn btn-standard mr-2">
          Back
        </button>
      </div>
      <div *ngIf="canApproveReject" class="float-right">
        <button
          (click)="onReject()"
          type="button"
          data-id="rejectBtn"
          id="rejectBtn"
          class="btn btn-special-reject mr-2"
        >
          Reject
        </button>
        <button
          (click)="onApprove()"
          type="button"
          data-id="approveBtn"
          id="approveBtn"
          class="btn btn-special-approve mr-2"
        >
          Approve
        </button>
      </div>
    </div>
  } @else {
    <div class="full-workflow-container">
      <app-approval-workflow-steps
        [approvalWorkflow]="approvalWorkflow"
        [canRegenerate]="canRegenerate"
        (regenerate)="onRegenerateApprovalWorkflow()"
        [documentStoreCode]="storeAvailableAdjustmentView?.storeCode"
        [documentStoreName]="storeAvailableAdjustmentView?.storeName"
      ></app-approval-workflow-steps>

      <div class="fixed-row-bottom form-row" style="margin: 0">
        <div class="float-left">
          <button (click)="onBack()" type="button" data-id="backBtn" id="backBtn" class="btn btn-standard mr-2">
            Back
          </button>
        </div>
      </div>
    </div>
  }
</ng-container>
